import { render } from "./FormacionTab.vue?vue&type=template&id=25f0b6dd"
import script from "./FormacionTab.vue?vue&type=script&lang=js"
export * from "./FormacionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__